<div class="header" [ngClass]="background">
  <p class="title">{{ title | translate }}</p>
  <on-ui-cover [cover]="cover"></on-ui-cover>
</div>

